module.exports = __webpack_public_path__ + "static/media/anna-lose.277591aa.png";